<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { loadScript } from '@/utils/loadScript'
import Wechat from '@/utils/wx.js'
import { configPath } from '@/request/api'
export default {
  created() {},

  mounted() {
    // this._setShare();
  },
  methods: {
    // 设置分享
    // _setShare(nickname) {
    //     let API_WX_CONFIG =
    //         "http://view.horsevision.cn/shengangdati/web/index.php?r=home-api/get-share-config";
    //     loadScript(
    //         `${API_WX_CONFIG}&url=${encodeURIComponent(location.href)}`,
    //         function () {
    //             Wechat.share({});
    //         }
    //     );
    // },
    // _setShare() {
    //     loadScript(
    //         `${configPath}&url=${encodeURIComponent(location.href)}`,
    //         function () {
    //             Wechat.share({});
    //         }
    //     );
    // },
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;

  /* 过渡动画 */
  .v-enter,
  .v-leave-to {
    opacity: 0;
  }
  .v-enter-active,
  .v-leave-active {
    transition: all 0.2s linear;
  }

  .centerImg {
    display: block;
    margin: 0 auto;
  }

  .flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flexAroundCenter {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .flexSpaceCenter {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flexCloumCenter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .flexSpaceCenterWrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .flexStartCenter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .flexSpaceStart {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  /* 超出隐藏 */
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ellipsis2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .ellipsis3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  // 自路由切换
  .children-router-enter,
  .children-router-leave-to {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }

  .children-router-enter-active {
    transition-duration: 300ms;
    transition-timing-function: ease-out;
  }

  .children-router-leave-active {
    transition-duration: 200ms;
    transition-timing-function: ease-in;
  }
}
</style>
